import type { MapLatLng } from "./MapView.types";

// Google's encoded polyline algorithm: each coordinate is a delta from the
// previous one, in 1e-5 degrees, as a series of 5-bit chunks offset by 63.
export function decodePolyline(encoded: string): MapLatLng[] {
  const path: MapLatLng[] = [];

  let index = 0;
  let lat = 0;
  let lng = 0;

  const readDelta = (): number => {
    let result = 0;
    let shift = 0;
    let byte: number;

    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);

    return result & 1 ? ~(result >> 1) : result >> 1;
  };

  while (index < encoded.length) {
    lat += readDelta();
    lng += readDelta();

    path.push({ lat: lat / 1e5, lng: lng / 1e5 });
  }

  return path;
}
